module.exports = __webpack_public_path__ + "static/media/rule3.f8688f17.png";